const {
    LOCAL_ENVIRONMENT,
    DEV_ENVIRONMENT,
    QA_ENVIRONMENT,
    STG_ENVIRONMENT,
    PROD_ENVIRONMENT,
    PROD_HIDDEN_ENVIRONMENT,
} = require('constants/index');

const {
    URL_STG_ES,
    URL_STG_DE,
    URL_STG_NL,
    URL_PROD_ES,
    URL_PROD_DE,
    URL_PROD_NL,
} = require('constants/multiLanguage');

export default {
    [LOCAL_ENVIRONMENT]: [
        { label: 'passport-country_es', url: URL_STG_ES },
        { label: 'passport-country_de', url: URL_STG_DE },
        { label: 'passport-country_nl', url: URL_STG_NL },
    ],
    [DEV_ENVIRONMENT]: [
        { label: 'passport-country_es', url: URL_STG_ES },
        { label: 'passport-country_de', url: URL_STG_DE },
        { label: 'passport-country_nl', url: URL_STG_NL },
    ],
    [QA_ENVIRONMENT]: [
        { label: 'passport-country_es', url: URL_STG_ES },
        { label: 'passport-country_de', url: URL_STG_DE },
        { label: 'passport-country_nl', url: URL_STG_NL },
    ],
    [STG_ENVIRONMENT]: [
        { label: 'passport-country_es', url: URL_STG_ES },
        { label: 'passport-country_de', url: URL_STG_DE },
        { label: 'passport-country_nl', url: URL_STG_NL },
    ],
    [PROD_HIDDEN_ENVIRONMENT]: [
        { label: 'passport-country_es', url: URL_PROD_ES },
        { label: 'passport-country_de', url: URL_PROD_DE },
        { label: 'passport-country_nl', url: URL_PROD_NL },
    ],
    [PROD_ENVIRONMENT]: [
        { label: 'passport-country_es', url: URL_PROD_ES },
        { label: 'passport-country_de', url: URL_PROD_DE },
        { label: 'passport-country_nl', url: URL_PROD_NL },
    ],
};
